import { Translation } from 'cng-common/features/translations'
import { Flex } from 'core-components/library/flex'
import { IColumn } from 'core-components/library/list/types'
import { PartnerRanks } from 'partner360/components/partnerRanks/PartnerRanks'
import { EntityManagementSwitcher } from 'partner360/widgets/gp360Administration/components/globalPartnerTable/components/globalPartnerDetailsContent/components/entityManagement/components/entityManagementSwitcher/EntityManagementSwitcher'
import {
  IEntityManagementSwitcherStateForSaving,
  TEntityManagementSwitcherField,
} from 'partner360/widgets/gp360Administration/components/globalPartnerTable/components/globalPartnerDetailsContent/components/entityManagement/models'
import { P360LinkWrapper } from 'partner360/widgets/gp360Administration/components/globalPartnerTable/components/globalPartnerDetailsContent/components/p360LinkWrapper/P360LinkWrapper'
import { IGlobalPartnerDetails } from 'partner360/widgets/gp360Administration/components/globalPartnerTable/models/globalPartnerDetails'
import { TRANSLATION_KEYS } from 'partner360/widgets/gp360Administration/translations'

interface IGetColumns {
  isPbm?: boolean
  onSwitchersStateChange: (
    partnerId: string,
    field: TEntityManagementSwitcherField,
    initialValues: Omit<IEntityManagementSwitcherStateForSaving, 'PartnerId'>
  ) => (flag: number) => void
  changedSwitcherState: IEntityManagementSwitcherStateForSaving[]
}
export const getColumns = ({
  isPbm,
  onSwitchersStateChange,
  changedSwitcherState,
}: IGetColumns): IColumn<IGlobalPartnerDetails>[] => {
  return [
    {
      field: 'PartnerId',
      title: TRANSLATION_KEYS.globalPartnerDetails.entityManagement.pid,
      priority: 2,
      titleRender: () => {
        return (
          <div>
            <Translation text={TRANSLATION_KEYS.globalPartnerDetails.entityManagement.pid} />
          </div>
        )
      },
      renderFunction: (item: IGlobalPartnerDetails) => {
        return (
          <div>
            <div>{item.PartnerId}</div>
          </div>
        )
      },
    },
    {
      field: 'PartnerName',
      title: TRANSLATION_KEYS.globalPartnerDetails.entityManagement.partnerName,
      titleRender: () => (
        <Translation text={TRANSLATION_KEYS.globalPartnerDetails.entityManagement.partnerName} />
      ),
      priority: 3,
      renderFunction: (item: IGlobalPartnerDetails) => {
        return <P360LinkWrapper text={item.PartnerName} partnerId={item.PartnerId} />
      },
    },
    {
      field: 'Geo',
      titleRender: () => {
        return (
          <div>
            <Translation text={TRANSLATION_KEYS.globalPartnerDetails.entityManagement.market} />
            <Translation text={TRANSLATION_KEYS.globalPartnerDetails.entityManagement.country} />
          </div>
        )
      },
      renderFunction: (item: IGlobalPartnerDetails) => {
        return (
          <Flex>
            <div>
              <div>{item.GeoMarket}</div>
              <div>{item.Geo}</div>
            </div>
          </Flex>
        )
      },
      title: TRANSLATION_KEYS.globalPartnerDetails.entityManagement.market,
      priority: 4,
    },
    {
      field: 'PartnerRanks',
      title: TRANSLATION_KEYS.globalPartnerDetails.entityManagement.partnerFlag,
      hideSettings: true,
      titleRender: () => (
        <Translation text={TRANSLATION_KEYS.globalPartnerDetails.entityManagement.partnerFlag} />
      ),
      priority: 6,
      renderFunction: (item: IGlobalPartnerDetails) => {
        return <PartnerRanks ranks={item.PartnerRanks || ''} />
      },
    },
    {
      field: 'PBM',
      title: isPbm
        ? TRANSLATION_KEYS.globalPartnerDetails.entityManagement.pbm
        : TRANSLATION_KEYS.globalPartnerDetails.entityManagement.dbm,
      titleRender: () => (
        <Translation
          text={
            isPbm
              ? TRANSLATION_KEYS.globalPartnerDetails.entityManagement.pbm
              : TRANSLATION_KEYS.globalPartnerDetails.entityManagement.dbm
          }
        />
      ),
      priority: 10,
    },
    {
      field: 'Manager',
      title: TRANSLATION_KEYS.globalPartnerDetails.entityManagement.manager,
      titleRender: () => (
        <Translation text={TRANSLATION_KEYS.globalPartnerDetails.entityManagement.manager} />
      ),
      priority: 11,
    },

    {
      field: 'IsRequired',
      hideSettings: true,
      title: TRANSLATION_KEYS.globalPartnerDetails.entityManagement.pid,
      priority: 12,
      titleRender: () => {
        return (
          <div>
            <Translation
              text={TRANSLATION_KEYS.globalPartnerDetails.entityManagement.requiredPlan}
            />
          </div>
        )
      },
      renderFunction: (item: IGlobalPartnerDetails) => {
        if (!item.PartnerId) {
          return <div />
        }
        return (
          <EntityManagementSwitcher
            initialValue={item.IsPlanRequired}
            field={'IsPlanRequired'}
            changedSwitcherState={changedSwitcherState}
            partnerId={item.PartnerId}
            onChange={onSwitchersStateChange(item.PartnerId, 'IsPlanRequired', {
              IsPlanRequired: item.IsPlanRequired,
              IsActualsSumUp: item.IsActualsSumUp,
            })}
          />
        )
      },
    },
    {
      field: 'IsActualsSumUp',
      hideSettings: true,
      title: TRANSLATION_KEYS.globalPartnerDetails.entityManagement.sumUpActuals,
      priority: 12,
      titleRender: () => {
        return (
          <div>
            <Translation
              text={TRANSLATION_KEYS.globalPartnerDetails.entityManagement.sumUpActuals}
            />
          </div>
        )
      },
      renderFunction: (item: IGlobalPartnerDetails) => {
        if (!item.PartnerId) {
          return <div />
        }
        return (
          <EntityManagementSwitcher
            initialValue={item.IsActualsSumUp}
            field={'IsActualsSumUp'}
            changedSwitcherState={changedSwitcherState}
            partnerId={item.PartnerId}
            onChange={onSwitchersStateChange(item.PartnerId, 'IsActualsSumUp', {
              IsPlanRequired: item.IsPlanRequired,
              IsActualsSumUp: item.IsActualsSumUp,
            })}
          />
        )
      },
    },
  ]
}
